import peoplecode from "refractor/peoplecode";
export default peoplecode;